// import { useContext } from "react";
// import { useRecoilValue } from "recoil";

import { Stack } from "@mui/material";

// import { settingsState } from "@/state/settings";
// import { GenAiContext } from "@/client/context";

interface Props {
  width?: number;
  style?: React.CSSProperties;
  lite?: boolean;
}

export const Logo = ({ style, lite }: Props) => {
  // const { theme } = useRecoilValue(settingsState);
  // const apiClient = useContext(GenAiContext);
  const src = lite ? "/qnb_logo_lite.svg" : "/qnb_logo.svg";

  // TODO: replace soon
  return (
    // <img src={apiClient.getLogoEndpoint(theme)} alt="logo" style={style} />

    <Stack
      direction="row"
      sx={{
        backgroundColor: "inherit",
        p: "8px",
        borderRadius: "10px",
      }}
    >
      <img src={src} alt="logo" style={style} />
    </Stack>
  );
};
